import { Component, OnInit } from '@angular/core';
import { ActivationEnd } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { RouterService } from '../services/router.service';
import { Page } from '../adapters/page';
import { MediaObserver } from '@angular/flex-layout';

export interface HomeSection {
	icon: string;
	text: string;
	path: string;
	module?: string;
	hidden?: boolean;
	disabled?: boolean;
}


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	year : number = (new Date()).getFullYear();

	username : string;


	sections : HomeSection[] = [];

	constructor(private routerService: RouterService,
				private authService: AuthService,
				private media: MediaObserver,
				private page: Page) {

		this.page.actionBarHidden = true;

		this.router.events.subscribe(event => {

			if (event instanceof ActivationEnd)
			{
				this.loadSections();
			}
		});
	}


	get router() {return this.routerService.router;}


	get xs() : boolean {
		return this.media.isActive('xs');
	}


	get admin() : boolean {return this.authService.user && this.authService.user.admin;}


	loadSections() {

		if (this.authService.user.admin)
		{
			this.sections = [
				{icon: 'user', text: 'Clientes administradores', path: '/admin/customers'},
				{icon: 'money', text: 'Administrar ofertas', path: '/admin/offers'},
				{icon: 'catalog', text: 'Catálogo de productos', path: '/admin/products'},
				{icon: 'receipt', text: 'Aprobar pagos realizados', path: '/admin/orders'}
			];
		}
		else
		{
			this.sections = [
				{icon: 'tracking', text: 'Seguimiento de compras', path: '/purchases', module: 'purchases'},
				{icon: 'finances', text: 'Gestión financiera', path: '/finances'},
				{icon: 'catalog', text: 'Catálogo de productos', path: '/products', module: 'products'},
				{icon: 'market', text: 'Compras', path: '/shopping', module: 'shopping'},
				{icon: 'business', text: 'Información del negocio', path: '/company', module: 'company'}
			];

			if (this.authService.user.role == 'admin')
				this.sections.push({icon: 'user', text: 'Administrar usuarios', path: '/users'});
		}
	}


	section(index: number) : HomeSection {

		const section = this.enabledSection(index);

		if (section.module)
		{
			const user = this.authService.user;

			section.disabled = (!user.admin && user.role != 'admin') && (user.modules == null || user.modules.indexOf(section.module) < 0);
		}

		return section;
	}

	enabledSection(index: number) : HomeSection {

		if (this.sections && this.sections.length > 0)
		{
			if (index < this.sections.length)
			{
				return this.sections[index];
			}
			else
			{
				const section = {...this.sections[0]};
				section.hidden = true;

				return section;
			}
		}
		else
		{
			return null;
		}
	}


	openSection(index: number) {

		const section = this.section(index);

		if (section.hidden || !section.path) return;

		this.router.navigate([section.path]);
	}



	ngOnInit() {

	}
}
